import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import classes from "./Download.module.css";
import API_BASE_URL from "../config";

const Download = () => {
    const { sessionId } = useParams();
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    // Quality Metrics
    const [groundingAvg, setGroundingAvg] = useState("N/A");
    const [degradedCount, setDegradedCount] = useState(0);
    const [qaScore, setQaScore] = useState("Passed");

    useEffect(() => {
        const fetchFinalState = async () => {
            try {
                // Use dynamic API variable
                const response = await fetch(`${API_BASE_URL}/api/v1/sessions/${sessionId}`);
                if (!response.ok) throw new Error("Failed to fetch session state.");

                const data = await response.json();
                const state = data.state || data;

                // 1. Calculate Grounding Average (from Verity Agent)
                const slides = state.slide_states || [];
                const scores = slides
                    .map(s => s.grounding_score)
                    .filter(score => score !== undefined && score !== null && score > 0);

                if (scores.length > 0) {
                    const avg = scores.reduce((a, b) => a + b, 0) / scores.length;
                    setGroundingAvg(`${(avg * 100).toFixed(0)}%`);
                }

                // 2. Calculate Degraded Count (from Sentinel Timeouts / Errors)
                const timeouts = state.agent_timeouts ? Object.keys(state.agent_timeouts).length : 0;
                setDegradedCount(timeouts);

                // 3. QA Score (Inspector)
                if (state.pipeline_status === "DONE" || state.pipeline_status === "ASSEMBLING") {
                    setQaScore("100%");
                } else {
                    setQaScore("Pending");
                }

                setIsLoading(false);
            } catch (err) {
                setError(err.message);
                setIsLoading(false);
            }
        };

        fetchFinalState();
    }, [sessionId]);

    const handleStartNew = () => {
        navigate("/chat");
    };

    if (isLoading) return <div style={{ textAlign: "center", marginTop: "50px" }}>Preparing your download...</div>;

    return (
        <div className={classes["container"]}>
            <div className={classes["card"]}>
                <div className={classes["iconWrapper"]}>✓</div>

                <h1 className={classes["title"]}>Your Deck is Ready!</h1>
                <p className={classes["subtitle"]}>
                    SlidesGen has successfully verified, illustrated, and assembled your presentation.
                </p>

                {error && <div className={classes["error"]}>{error}</div>}

                <div className={classes["metricsGrid"]}>
                    <div className={classes["metricCard"]}>
                        <div className={classes["metricValue"]}>{groundingAvg}</div>
                        <div className={classes["metricLabel"]}>Grounding Score</div>
                    </div>

                    <div className={classes["metricCard"]}>
                        <div className={classes["metricValue"]} style={{ color: degradedCount > 0 ? "#ef4444" : "#0f172a" }}>
                            {degradedCount}
                        </div>
                        <div className={classes["metricLabel"]}>Ops Fallbacks</div>
                    </div>

                    <div className={classes["metricCard"]}>
                        <div className={classes["metricValue"]} style={{ color: "#22c55e" }}>
                            {qaScore}
                        </div>
                        <div className={classes["metricLabel"]}>QA Inspector</div>
                    </div>
                </div>

                {/* Use dynamic API variable for download anchor */}
                <a
                    href={`${API_BASE_URL}/api/v1/sessions/${sessionId}/download`}
                    className={classes["downloadBtn"]}
                    download={`SlidesGen_${sessionId}.pptx`}
                >
                    Download Presentation (.pptx)
                </a>

                <button className={classes["newSessionBtn"]} onClick={handleStartNew}>
                    Start a New Presentation
                </button>
            </div>
        </div>
    );
};

export default Download;